import React, { useState } from "react";
import "./BrokenLinksTable.css";

function BrokenLinksTable(props) {
  const [show, setShow] = useState(true);

  const rows = props.links
    ? props.links.map((link, index) => (
        <BrokenLinksRow key={index} link={link} url={props.url} />
      ))
    : [];

  const triggerIcon = show ? (
    <img
      src="images/down_triangle.png"
      alt="Click here to close broken links table"
      className="broken-links-table__icon--open"
      onClick={() => setShow(!show)}
    />
  ) : (
    <img
      src="images/right_triangle.png"
      alt="Click here to open broken links table"
      className="broken-links-table__icon--close"
      onClick={() => setShow(!show)}
    />
  );

  return (
    <div>
      <h2>Broken Links {triggerIcon}</h2>

      {show && (
        <table className="broken-links-table">
          <thead>
            <tr>
              <th>BROKEN LINK</th>
              <th>PAGE TEXT</th>
              <th>PAGE</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      )}
    </div>
  );
}

function BrokenLinksRow({ link, url }) {
  return (
    <tr>
      <td>{link.href}</td>
      <td>{link.innerText}</td>
      <td>{url}</td>
    </tr>
  );
}

export default BrokenLinksTable;
